import React, { useState } from "react";
import "./Developer.css";
import Pasindu from './Profile_img/WhatsApp_Image_2023-10-10_at_11.13.45_bac404bb-removebg-preview.png'
import Nimantha from './Profile_img/WhatsApp_Image_2023-06-23_at_9.46.45_AM-removebg-preview.png'
import Sanjana from './Profile_img/sinjana.jpg'
import AnimateOnScroll from 'react-animate-on-scroll'; // Import the animation component
import 'animate.css/animate.min.css'; // Import animate.css for animations

export default function Developer() {
  const [isHovered, setIsHovered] = useState(false);

  const toggleHover = () => {
    setIsHovered(!isHovered);
  };

  return (
    <section id="service">
      <div className="container mt-5" style={{paddingTop:20}}>
      <div className="row" style={{ marginTop: 200 }}>
        {/* Left Side Card */}
        <div
          className={`col-md-6 mb-3 ${isHovered ? "hovered" : ""}`}
          onMouseEnter={toggleHover}
          onMouseLeave={toggleHover}
        >
           <AnimateOnScroll
              animateIn="animate__slideInLeft" // Animation class from animate.css
              animateOnce={true} // Only animate once
            >
          <div
            className="card profiles"
            style={{ borderRadius: 50, padding: 10, textAlign: "end" }}
          >
           <div className="nim">
           <img
              src={Nimantha}
              className="card-img-top"
              alt="Left Card Image"
              style={{borderRadius:50}}
            />
           </div>
            <div className="card-body dis_div">
              {/* Content for the left side card */}
              <h4 className="abiur">"I'm a fullstack developer in android,software and web"</h4>
              <h5 className="card-title div-tit">Nimantha Perera <i class="fa fa-leaf"></i></h5>
              <p className="card-text div-pro">(Full Stack Software Engineer)</p>
            </div>
          </div>
          </AnimateOnScroll>
        </div>

        {/* Right Side Card */}
        <div
          className={`col-md-6 mb-3 ${isHovered ? "hovered" : ""}`}
          onMouseEnter={toggleHover}
          onMouseLeave={toggleHover}
        >
          <AnimateOnScroll
              animateIn="animate__slideInRight" // Animation class from animate.css
              animateOnce={true} // Only animate once
            >
          <div
            className="card pasi"
            style={{
              borderRadius: 50,
              padding: 10,
             
              textAlign: "end",
            }}
          >
            <div className="pas">
            <img
              src={Pasindu}
              className="card-img-top"
              style={{borderRadius:50}}
              alt="Right Card Image"
            />
            </div>
            <div className="card-body dis_div">
              {/* Content for the right side card */}
              <h4 className="abiur" >"I'm a fullstack developer in android,software and web"</h4>
              <h5 className="card-title div-tit">Pasindu Hansaka</h5>
              <p className="card-text div-pro">(Full Stack Software Engineer)</p>
            </div>
          </div>
          </AnimateOnScroll>
        </div>


        <div
          className={`col-md-6 mb-3 ${isHovered ? "hovered" : ""}`}
          onMouseEnter={toggleHover}
          onMouseLeave={toggleHover}
        >
          <AnimateOnScroll
              animateIn="animate__slideInLeft" // Animation class from animate.css
              animateOnce={true} // Only animate once
            >
          <div
            className="card"
            style={{
              borderRadius: 50,
              padding: 10,
              marginTop: 0,
              textAlign: "end",
            }}
          >
            <div className="sanj">
            <img
              src={Sanjana}
              className="card-img-top"
              alt="Left Card Image"
              style={{borderRadius:50}}
            />
            </div>
            <div className="card-body dis_div">
              {/* Content for the right side card */}
              <h4 className="abiur">"I'm a UI/UX designer in android,software and web"</h4>
              <h5 className="card-title div-tit">Sanjana Ranaweera</h5>
              <p className="card-text div-pro">(Full Stack Software Engineer)</p>
            </div>
          </div>
          </AnimateOnScroll>
        </div>
      </div>
    </div>
    </section>
  );
}
